// extracted by mini-css-extract-plugin
export default {"button":"Lq-z","reviewSort":"Mq-z"};